export type AppEnv = 'prod' | 'stage' | 'local';

export const APP_ENV: AppEnv = 'stage';
export const APP_VERSION = '1.0.0';
export const RELEASE_NOTES = {
  id: '1.1.0',
  title: 'What’s new in Passport',
  body: 'Switch role and organisation without signing out.\n\n• On a computer, use the bar at the top. On a phone, use the pill in the header. Your current role is highlighted in Passport teal.\n• Switch among Employee, Manager, and Verifier when your account already has those roles.\n• Open another organisation or site from the same control. Passport remembers the role you chose and uses it the next time you sign in, when that organisation still includes it.\n• An organisation stays in the list even when it does not include your current role. Opening it takes you to a role you do have there.',
  show: true,
};
